<template>
  <div v-loading="loading" element-loading-background="transparent" class="h-full overflow-hidden">
    <el-scrollbar class="h-[calc(100%-62px)] overflow-x-hidden">
      <!-- 任务信息 -->
      <crowd-task-card v-if="isCrowd" :info="info" :duty="duty" :term="term" />
      <match-task-card v-else :info="info" :duty="duty" :term="term" />

      <!-- 订单信息 -->
      <crowd-order-card v-if="isCrowd" :info="info" :term="term" />
      <match-order-card v-else :info="info" :term="term" />

      <!-- 子订单信息 -->
      <crowd-sub-orders v-if="isCrowd" :info="info" :term="term" @reload="fetchData" />
      <match-sub-orders v-else :info="info" :term="term" @reload="fetchData" />

      <!-- 订单日志 -->
      <div class="base-card-info">
        <div class="info-card-title">
          订单日志
        </div>

        <el-table class="normal-table" :border="true" :scrollbar-always-on="true" :data="logs" :max-height="300">
          <el-table-column align="left" type="index" label="序号" :min-width="60" />
          <el-table-column align="left" prop="operationContext" label="日志内容" show-overflow-tooltip :min-width="260" />
          <el-table-column align="left" prop="logTime" label="操作时间" :min-width="170" />
          <el-table-column align="left" prop="creator" label="操作人" :min-width="120" />
        </el-table>
      </div>
    </el-scrollbar>

    <el-button class="mt-4" @click="closeAndBack">
      <svg-icon icon="icon-park-outline:return" />返回
    </el-button>

    <adjust-sub-order-fee
      :visible="showAdjustServiceFee"
      :data="info"
      :module="module"
      @close="showAdjustServiceFee = false"
      @success="fetchData"
    />
  </div>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router';
import { ElMessage } from 'element-plus';
import { SvgIcon } from '@vue3/components';
import { computed, PropType, ref } from 'vue';
import { querySettlementDetail, useTabsStore } from '@core/main';
import AdjustSubOrderFee from './dialogs/AdjustSubOrderFee.vue';
import CrowdOrderCard from './widgets/order-info/CrowdOrderCard.vue';
import MatchOrderCard from './widgets/order-info/MatchOrderCard.vue';
import CrowdTaskCard from './widgets/order-info/CrowdTaskCard.vue';
import MatchTaskCard from './widgets/order-info/MatchTaskCard.vue';
import CrowdSubOrders from './widgets/order-info/CrowdSubOrders.vue';
import MatchSubOrders from './widgets/order-info/MatchSubOrders.vue';
import { ISettlementOrderDetail, ISettlementOrderDuty } from '@core/main/types';

defineOptions({ name: 'SettlementInfo' }); // 结算订单详情

const { closeAndBack } = useTabsStore();

const route = useRoute();

const props = defineProps({
  term: {
    type: String as PropType<'company' | 'agent' | 'saas' | 'server'>,
    required: true,
  },
  module: {
    type: String as PropType<'zhongbao' | 'cuohe'>,
    default: 'zhongbao',
  },
});

const loading = ref(false);
const showAdjustServiceFee = ref(false);
const info = ref({} as ISettlementOrderDetail);

const isCrowd = computed(() => props.module === 'zhongbao');
const duty = computed(() => info.value.duty || {} as ISettlementOrderDuty);
const logs = computed(() => info.value.orderLogs || []);

async function fetchData() {
  loading.value = true;

  try {
    info.value = await querySettlementDetail(Number(route.query.id), props.module);
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }

  loading.value = false;
}

fetchData();
</script>

<style lang="scss" scoped>
.h-icon {
  @apply text-[var(--color-primary)] ml-1;

  width: 16px !important;
  height: 16px !important;
}
</style>

